import { SectionHeading } from "./SectionHeading";
import { Reveal, RevealMask } from "./motion-primitives";
import { CtaButton } from "./CtaButton";

// Premium editorial feature spread for the first Discoverography story.
export const Discoverography = () => {
  return (
    <section
      id="discoverography"
      data-testid="discoverography-section"
      className="mx-auto max-w-[1400px] px-6 py-16 sm:px-10 lg:px-16 lg:py-20"
    >
      <SectionHeading
        overline="Travel stories"
        title="Discoverography"
        intro="Travel stories for people who'd rather know where to go than everywhere to go."
        testId="discoverography-heading"
      />

      <div className="mt-10 grid grid-cols-1 items-center gap-8 lg:mt-14 lg:grid-cols-12 lg:gap-12">
        <RevealMask className="relative lg:col-span-7">
          <div className="relative aspect-[16/10] w-full overflow-hidden sm:aspect-[3/2] lg:aspect-auto lg:h-[440px]">
            <img
              src="https://images.unsplash.com/photo-1500217052183-bc01eee1a74e?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000"
              alt="A single cocktail lit in a dark Da Nang bar"
              className="h-full w-full object-cover object-[center_40%]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/60 via-transparent to-transparent" />
          </div>
        </RevealMask>

        <div className="flex flex-col justify-center lg:col-span-5">
          <Reveal>
            <span className="font-sans text-xs uppercase tracking-[0.3em] text-teal">
              Da Nang · 2 places
            </span>
          </Reveal>
          <Reveal delay={0.06}>
            <h3 className="mt-6 font-serif text-4xl font-light leading-[1.05] tracking-tight text-cream sm:text-5xl lg:text-6xl">
              Da Nang After Dark
            </h3>
          </Reveal>
          <Reveal delay={0.12}>
            <p className="mt-7 max-w-md font-sans text-lg leading-relaxed text-sand">
              Two hidden cocktail bars worth finding.
            </p>
          </Reveal>
          <Reveal delay={0.18}>
            <div className="mt-10">
              <CtaButton testId="discoverography-read-cta" variant="secondary" to="/discoverography/da-nang-after-dark">
                Explore the collection
              </CtaButton>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
